import { Button } from 'antd';
import { HistoryBookIcon } from '@/assets/icons';
import { ProfileFormFooter } from '@/components/profile';
import { COMPANY_PROFILE_FORM_SECTIONS } from '../../companyProfileSections';
import { useCompanyGeneralDataForm } from '../CompanyGeneralDataFormContext';

/** Save / cancel footer for the profile and the edit page. */
export default function CompanyFormFooter() {
  const {
    companyId,
    discardChanges,
    handleReset,
    isEdited,
    isPending,
    isProfile,
    onCancel,
    profileSection,
    readOnly,
    saveTile,
    setHistoryOpen,
    t,
  } = useCompanyGeneralDataForm();

  return (
    <>
      {isProfile ? (
        !readOnly &&
        COMPANY_PROFILE_FORM_SECTIONS.includes(profileSection) && (
          <ProfileFormFooter
            isPending={isPending}
            onSave={saveTile}
            onCancel={() => {
              discardChanges();
              onCancel?.();
            }}
          />
        )
      ) : (
        <div className="form-footer form-footer--sticky !grid-cols-1">
          <div className="flex w-full items-center justify-between gap-2">
            {/* History button on the left */}
            <div className="flex">
              {isEdited && companyId && (
                <Button
                  type="default"
                  onClick={() => setHistoryOpen(true)}
                  className="btn-default btn-default--hover"
                >
                  <span className="flex items-center gap-2">
                    <HistoryBookIcon style={{ fontSize: '18.2px' }} />
                    {t('history', { ns: 'forms' })}
                  </span>
                </Button>
              )}
            </div>

            {/* Action buttons on the right */}
            <div className="flex gap-2">
              <Button
                type="default"
                disabled={isPending}
                className="btn-default btn-default--hover"
                onClick={handleReset}
              >
                {t('reset')}
              </Button>

              <Button
                type="primary"
                htmlType="submit"
                loading={isPending}
                disabled={isPending}
                className="btn-primary"
              >
                {t(isEdited ? 'save' : 'submit')}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
